<div class="modal-overlay" (click)="onCancel()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="modal-icon"><mat-icon aria-hidden="true">fiber_new</mat-icon></div>
      <h3 class="modal-title">Créer une nouvelle version</h3>
    </div>
    <div class="modal-body">
      <p class="choice-label">Comment souhaitez-vous créer cette version ?</p>
      <div class="choice-cards">
        <div class="choice-card" [class.selected]="choiceType === 'scratch'" (click)="choiceType = 'scratch'">
          <div class="choice-icon"><mat-icon aria-hidden="true">description</mat-icon></div>
          <div class="choice-text">
            <strong>À partir de zéro</strong>
            <span>Commencer avec une liste vide</span>
          </div>
        </div>
        <div class="choice-card"
             [class.selected]="choiceType === 'duplicate'"
             [class.disabled]="!canDuplicate"
             (click)="canDuplicate ? choiceType = 'duplicate' : null">
          <div class="choice-icon"><mat-icon aria-hidden="true">content_copy</mat-icon></div>
          <div class="choice-text">
            <strong>Dupliquer l'actuelle</strong>
            <span>{{ canDuplicate ? 'Copier les types de la version sélectionnée' : 'Aucune version à dupliquer' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onCancel()">Annuler</button>
      <button type="button" class="btn btn-primary" (click)="onConfirm()">Créer</button>
    </div>
  </div>
</div>

